module.exports = __webpack_public_path__ + "img/bySkill.5bb7125a.svg";